module.exports = __webpack_public_path__ + "static/img/6_1.504bfd70.jpg";